// import AuthService from '../services/auth.service';
import * as main from '../services/main.service';
import * as constant from '../services/constant';
const user = main.parseJwtByLocalStorage(constant.TOKEN_KEY);
const initialState = user ?
    { status: { loggedIn: true }, user } :
    { status: { loggedIn: false }, user: null };
export const auth = {
    namespaced: true,
    state: {
        token:initialState,
        isAdmin:''
    },
    actions: {
        login({ commit }) {
            let getUser = main.parseJwtByLocalStorage(constant.TOKEN_KEY)
            commit('loginSuccess', getUser);
        },
        logout({ commit }) {
            localStorage.removeItem(constant.TOKEN_KEY)
            commit('logout')
        },
        NotFoundUser({ commit }) {
            localStorage.removeItem(constant.TOKEN_KEY)
            commit('loginFailure')
        }
    },
    getters: {
        gettest(state) {
            return 'asdasd';
        },
        getloggedIn(state) {
            return state.token.status.loggedIn;
        },
        getUser(state) {
            return state.token.user;
        }
    },
    mutations: {
        loginSuccess(state, user) {
            state.token.status.loggedIn = true;
            state.token.user = user;
        },
        loginFailure(state) {
            state.token.status.loggedIn = false;
            state.token.user = null;
        },
        logout(state) {
            state.token.status.loggedIn = false;
            state.token.user = null;
        },
    }
};
